import type { Event } from 'models';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Delete2LineIcon, Modal, message } from 'ui';
import { useCancelEvent as useCancelEventMutation } from '../queries';

export const useCancelEvent = () => {
  const { t } = useTranslation();
  const [modal, contextHolder] = Modal.useModal();
  const { mutateAsync: cancelEvent } = useCancelEventMutation();

  const confirm = useCallback(
    ({ event }: { event: Event }) => {
      const handleDeleteEvent = async () => {
        await cancelEvent(
          { eventId: event.id },
          {
            onSuccess() {
              message.success('Event canceled successfully');
            },
          },
        );
      };

      modal.confirm({
        content: 'This action is irreversible!',
        icon: <Delete2LineIcon type="error" />,
        okText: 'Cancel event',
        onOk: handleDeleteEvent,
        title: t('Are you sure you want to cancel {{name}}?', { name: event.name }),
        type: 'error',
      });
    },
    [cancelEvent, modal, t],
  );

  return useMemo(() => ({ confirm, contextHolder }), [confirm, contextHolder]);
};
